import React from 'react';
// Shared imports
import settings from '../../../settings';
import { redirectTo } from '../../../SharedUI/functions';


// This object creates a step title with an exit button
const StepTitleExitDefaultProps = {
    content: <></>
};

function onExit () {
    // Redirect to 'home' (REDIRECT BOOKMARK)
    redirectTo('');
}

function StepTitleExit(props = StepTitleExitDefaultProps) {
    const { content } = props;
    return (
        <h1 className="step-title-exit">
            {
                content
            }
            <img onClick={onExit} src={`${settings.assetsPath}img/icons/bouwsteen-sluit.png`} alt="Verlaat gamestudio"/>
        </h1>
    );
}

export default StepTitleExit;